import stayCurious from "../assets/images/stayCuriousText.svg";
import callingCard from "../assets/images/callingCard.png";
import transceiver from "../assets/images/transceiver.png";
import protoText from "../assets/images/M1-A-R.png";
import dongle from "../assets/images/dongle.png";
import qrCode from "../assets/images/qrCode.png";
// mission2
import m2Rookie1D from "../assets/images/M2-R-D.png";
import m2Rookie2R from "../assets/images/M2-R-R.png";
import m2IntermediateR from "../assets/images/M2-I-R.png";
import m2IntermediateD from "../assets/images/M2-I-D.png";
import m2AdvancedR from "../assets/images/M2-A-R.png";
import m2AdvancedD from "../assets/images/M2-A-D.png";
// mission3
import m3RookieR from "../assets/images/M3-R-R.png";
import m3RookieD from "../assets/images/M3-R-D.png";
import m3IntermediateR from "../assets/images/M3-I-R.png";
import m3IntermediateD from "../assets/images/M3-I-D.png";
import m3AdvancedR from "../assets/images/M3-A-R.png";
import m3AdvancedD from "../assets/images/M3-A-D.png";
// mission4
import m4RookieR from "../assets/images/M4-R-A.png";
import m4RookieD from "../assets/images/M4-R-D.png";
import m4IntermediateR from "../assets/images/M4-I-R.png";
import m4IntermediateD from "../assets/images/M4-I-D.png";
import m4AdvancedR from "../assets/images/M4-A-R.png";
import m4AdvancedD from "../assets/images/M4-A-D.png";

export {
  //m2
  m2Rookie2R,
  m2Rookie1D,
  m2IntermediateR,
  m2IntermediateD,
  m2AdvancedR,
  m2AdvancedD,
  //m3
  m3RookieR,
  m3RookieD,
  m3IntermediateR,
  m3IntermediateD,
  m3AdvancedR,
  m3AdvancedD,
  //m4
  m4RookieR,
  m4RookieD,
  m4IntermediateR,
  m4IntermediateD,
  m4AdvancedR,
  m4AdvancedD,
};

export const clueData = [
  {
    id: "mission-1",
    title: "WHAT CAN IT DO?",
    missionTitle: "Secrets of the Circuit",
    position: {
      x: 540,
      y: 335,
    },
    coins: {
      rookie: [
        {
          id: "clue-1",
          type: "image",
          src: stayCurious,
          level: "rookie",
          pinned: false,
          position: {
            x: 535,
            y: 265,
          },
          isPin: false,
          pinPosition: {
            x: 20,
            y: -40,
          },
          clueType: "real",
          title: "ByteFox Logo Sticker",
          meaning:
            "Inside the drone’s circuitry, you found a small sticker bearing the logo of a fox and the phrase, ‘Stay Curious’. This was no accident—ByteFox has a reputation for leaving their signature on their creations, a clear indication of their need for recognition. From the start, this operation was a display of technical skill, not subtlety.",
        },
        {
          id: "clue-2",
          type: "image",
          src: callingCard,
          level: "rookie",
          pinned: false,
          position: {
            x: 420,
            y: 270,
          },
          rotation: 40,
          isPin: false,
          clueType: "decoy",
          decoy:
            "A circuit diagram labelled Restricted Military Use, with a stamped serial number, later revealed as a generic component blueprint. ByteFox used this decoy to hint at military involvement, adding a layer of drama to mislead the player into thinking the drone was part of a classified military project.",
        },
      ],
      intermediate: [
        {
          id: "clue-4",
          type: "image",
          src: qrCode,
          level: "intermediate",
          pinned: false,
          position: {
            x: 666,
            y: 355,
          },
          isPin: false,
          rotation: -31,
          clueType: "real",
          title: "QR Code on Microcontroller",
          meaning:
            "Etched onto the microcontroller was a QR code leading to ByteFox’s cryptic video: ‘Can You\n    Crack the Fox’s Den?’ This teaser showcased ByteFox’s playful personality and their love for puzzles\n    and challenges, inviting curious minds to engage. It’s as though the drone wasn’t just a breach—it\n    was an open invitation.",
        },
        {
          id: "clue-3",
          type: "image",
          src: transceiver,
          level: "intermediate",
          pinned: false,
          position: {
            x: 645,
            y: 275,
          },
          isPin: false,
          rotation: 12,
          clueType: "decoy",
          decoy:
            "A microchip with engraved coordinates pointing to a random ocean location.\nByteFox engraved these false coordinates to create a wild goose chase, suggesting an offshore\nlaunch point to divert attention from the real source.",
        },
      ],
      advanced: [
        {
          id: "clue-5",
          type: "image",
          src: protoText,
          level: "advanced",
          pinned: false,
          position: {
            x: 500,
            y: 360,
          },
          isPin: false,
          clueType: "real",
          title: `Circuit Engraving: 'Proto-5.3: Built for ByteFox'`,
          meaning:
            "While cracking the console, you uncovered a password hint with the playful phrase, ‘What does the fox say? Stay Curious.’ This ties directly to ByteFox’s persona—cheeky, clever, and always leaving breadcrumbs for those willing to follow. It’s another example of how ByteFox embeds their personality into their work.",
        },
        {
          id: "clue-6",
          type: "image",
          src: dongle,
          level: "advanced",
          pinned: false,
          position: {
            x: 610,
            y: 390,
          },
          rotation: -135,
          isPin: false,
          clueType: "decoy",
          decoy:
            "A USB flash drive embedded in the drone, labelled with the logo of a prominent tech company. When analysed, it contains dummy files. ByteFox planted the flash drive to imply corporate involvement, leading the investigator to suspect the drone was created with advanced private sector collaboration.",
        },
      ],
    },
  },
  {
    id: "mission-2",
    title: "WHO MADE IT?",
    missionTitle: "Access Denied",
    position: {
      x: 430,
      y: 190,
    },
    coins: {
      rookie: [
        {
          id: "clue-8",
          type: "image",
          src: m2Rookie2R,
          level: "rookie",
          pinned: false,
          isPin: true,
          position: {
            x: 190,
            y: 232,
          },
          rotation: -6.94,
          pinPosition: {
            x: 100,
            y: -25,
          },
          zIndex: 101,
          title: "Password Hint: 'What does the fox say? Stay Curious.'",
          clueType: "real",
          meaning: `A password hint appeared during your attempts to unlock the console: ‘What does the fox say? Stay Curious.’ ByteFox’s signature humour and intellect are woven into every aspect of this operation.`,
        },
        {
          id: "clue-7",
          type: "image",
          src: m2Rookie1D,
          level: "rookie",
          pinned: false,
          position: {
            x: 185,
            y: 286,
          },
          zIndex: 102,
          isPin: false,
          rotation: -3.37,
          clueType: "decoy",
          decoy:
            "A pop-up error message with the text, Remote server not found, and a non-functioning retry button.\nByteFox introduced this error to suggest the console was attempting to communicate with an external system, leading investigators to chase a non-existent collaborator.",
        },
      ],
      intermediate: [
        {
          id: "clue-9",
          type: "image",
          src: m2IntermediateR,
          level: "intermediate",
          pinned: false,
          isPin: true,
          position: {
            x: 180,
            y: 90,
          },
          rotation: 0,
          pinPosition: {
            x: -75,
            y: -25,
          },
          zIndex: 101,
          clueType: "real",
          title: "Debugging Comment: 'Uncrackable, trust me. ByteFox.'",
          meaning: `Deep in the drone’s logs, you found a debugging comment signed by ByteFox: ‘Uncrackable, trust me.’ It was a challenge more than a statement, daring investigators like yourself to prove them wrong. ByteFox thrives on competition, using their creations to test others’ limits.`,
        },
        {
          id: "clue-10",
          type: "image",
          src: m2IntermediateD,
          level: "intermediate",
          pinned: false,
          isPin: false,
          position: {
            x: 168,
            y: 160,
          },
          rotation: 5.07,
          pinPosition: {
            x: 0,
            y: -40,
          },
          clueType: "decoy",
          decoy: `A text file labelled Team Roster, with pseudonyms disguising ByteFox's name. ByteFox designed this fake roster to imply they were working with a team of co-conspirators,\ncreating confusion about the drone's origin.`,
        },
      ],
      advanced: [
        {
          id: "clue-11",
          type: "image",
          src: m2AdvancedR,
          level: "advanced",
          pinned: false,
          isPin: true,
          position: {
            x: 445,
            y: 110,
          },
          pinPosition: {
            x: 50,
            y: -30,
          },
          rotation: -8.93,
          clueType: "real",
          title: "Login Metadata: 'Last Login from Cambridge.'",
          meaning: `The login metadata revealed the last access point was in Cambridge, where ByteFox is known to operate. This ties their physical presence to the drone’s activities.`,
        },
        {
          id: "clue-12",
          type: "image",
          src: m2AdvancedD,
          level: "advanced",
          pinned: false,
          isPin: true,
          position: {
            x: 695,
            y: 130,
          },
          rotation: 0,
          pinPosition: {
            x: -10,
            y: -65,
          },
          clueType: "decoy",
          decoy: `A fragmented password recovery email chain implying an external breach attempt. ByteFox crafted this decoy to suggest the drone was hacked externally, buying time and obscuring their direct involvement.`,
        },
      ],
    },
  },
  {
    id: "mission-3",
    title: "WHERE DID IT COME FROM?",
    position: {
      x: 740,
      y: 225,
    },
    missionTitle: "Digital Breadcrumbs",
    coins: {
      rookie: [
        {
          id: "clue-14",
          type: "image",
          src: m3RookieR,
          level: "rookie",
          pinned: false,
          position: {
            x: 880,
            y: 145,
          },
          rotation: 16,
          isPin: true,
          pinPosition: {
            x: -60,
            y: -65,
          },
          zIndex: 101,
          title: `GPS Data to ByteFox’s Filming Location`,
          clueType: "real",
          meaning: `The drone’s journey began at a tech park in Bristol, frequently featured in ByteFox’s videos. This was no coincidence—it was their personal launch pad.`,
        },
        {
          id: "clue-13",
          type: "image",
          src: m3RookieD,
          level: "rookie",
          pinned: false,
          position: {
            x: 1020,
            y: 80,
          },
          rotation: 0,
          isPin: false,
          pinPosition: {
            x: 0,
            y: -24,
          },
          clueType: "decoy",
          decoy: `Coordinates to Stonehenge, a famous tourist location with a timestamp matching the drone's activity log. ByteFox included this playful location to distract investigators with an implausible yet intriguing origin story playing on the site's mystique.`,
        },
      ],
      intermediate: [
        {
          id: "clue-15",
          type: "image",
          src: m3IntermediateR,
          level: "intermediate",
          pinned: false,
          position: {
            x: 1000,
            y: 220,
          },
          rotation: 11.65,
          zIndex: 102,
          isPin: true,
          pinPosition: {
            x: 45,
            y: -50,
          },
          clueType: "real",
          title: "GPS Stop at Electronics Store",
          meaning: `The drone made a stop at an electronics store, where a receipt signed ‘F. A. O. Foxy Parts’ tied\nByteFox to the purchase of critical components.`,
        },
        {
          id: "clue-16",
          type: "image",
          src: m3IntermediateD,
          level: "intermediate",
          pinned: false,
          position: {
            x: 860,
            y: 288,
          },
          rotation: -4.44,
          isPin: true,
          pinPosition: {
            x: -10,
            y: -45,
          },
          clueType: "decoy",
          decoy:
            "A waypoint labelled Refuel Stop at a fast food chain accompanied by a mock receipt.\nByteFox used this humorous diversion to imply the drone made an unnecessary pit stop, leading investigators away from the real trail.",
        },
      ],
      advanced: [
        {
          id: "clue-17",
          type: "image",
          src: m3AdvancedR,
          level: "advanced",
          pinned: false,
          position: {
            x: 1030,
            y: 325,
          },
          rotation: 5.45,
          isPin: false,
          pinPosition: {
            x: 70,
            y: 10,
          },
          clueType: "real",
          title: "GPS Data Revealing Cambridge Workshop",
          meaning: `Further GPS analysis revealed the drone’s arrival at a workshop in Cambridge—ByteFox’s known base of operations. The trail couldn’t be clearer.`,
        },
        {
          id: "clue-18",
          type: "image",
          src: m3AdvancedD,
          level: "advanced",
          pinned: false,
          position: {
            x: 1000,
            y: 400,
          },
          rotation: 0,
          isPin: true,
          pinPosition: {
            x: 0,
            y: -30,
          },
          clueType: "decoy",
          decoy: `A scrambled location marked Restricted, resembling a government research site, but fabricated. ByteFox created this decoy to suggest governmental involvement, exploiting common assumptions about secretive operations.`,
        },
      ],
    },
  },
  {
    id: "mission-4",
    title: "WHAT WAS IT OBSERVING?",
    position: {
      x: 340,
      y: 355,
    },
    missionTitle: "Visual Decipher",
    coins: {
      rookie: [
        {
          id: "clue-19",
          type: "image",
          src: m4RookieR,
          level: "rookie",
          pinned: false,
          position: {
            x: 1015,
            y: 490,
          },
          rotation: -8.68,
          isPin: true,
          pinPosition: {
            x: 65,
            y: -45,
          },
          clueType: "real",
          title: "Decoded Image of ByteFox Hosting a Public Event",
          meaning:
            "You uncovered an image of ByteFox speaking at a public science fair. This drone wasn’t just\n  breaching security—it was documenting their presence.",
        },
        {
          id: "clue-20",
          type: "image",
          src: m4RookieD,
          level: "rookie",
          pinned: false,
          position: {
            x: 1022,
            y: 580,
          },
          rotation: 8.78,
          isPin: false,
          pinPosition: {
            x: 70,
            y: -20,
          },
          clueType: "decoy",
          decoy: `A blurred aerial image of a site labeled "Classified," later clarified as an art installation.​ ByteFox fabricated this image to amplify intrigue and make the drone’s activities seem more suspicious than they were.`,
        },
      ],
      intermediate: [
        {
          id: "clue-21",
          type: "image",
          src: m4IntermediateR,
          level: "intermediate",
          pinned: false,
          position: {
            x: 780,
            y: 505,
          },
          rotation: 4,
          isPin: false,
          pinPosition: {
            x: 172,
            y: 8,
          },
          clueType: "real",
          title: "Metadata Watermark with ByteFox’s YouTube Intro",
          meaning: `Embedded in the image metadata was ByteFox’s YouTube intro sequence. It’s a deliberate signature, tying this operation to their digital presence.`,
        },
        {
          id: "clue-22",
          type: "image",
          src: m4IntermediateD,
          level: "intermediate",
          pinned: false,
          position: {
            x: 910,
            y: 572,
          },
          rotation: -2,
          isPin: true,
          pinPosition: {
            x: 40,
            y: -55,
          },
          clueType: "decoy",
          decoy: `Geolocation data pointing to a random offshore buoy, presented as if it could be a drone rendezvous point.​ ByteFox included this decoy to suggest coordinated activity with other drones, adding complexity to the investigation.`,
        },
      ],
      advanced: [
        {
          id: "clue-23",
          type: "image",
          src: m4AdvancedR,
          level: "advanced",
          pinned: false,
          position: {
            x: 575,
            y: 565,
          },
          rotation: -7,
          isPin: false,
          pinPosition: {
            x: 172,
            y: 8,
          },
          clueType: "real",
          title: "Hidden Teaser Message: '#ComingSoon: The Fox’s Big Reveal.'",
          meaning: `Buried in the encrypted files was a teaser message: ‘#ComingSoon: The Fox’s Big Reveal.’ByteFox clearly planned this as a spectacle, not just a technical exercise.`,
        },
        {
          id: "clue-24",
          type: "image",
          src: m4AdvancedD,
          level: "advanced",
          pinned: false,
          position: {
            x: 420,
            y: 575,
          },
          rotation: 10,
          isPin: false,
          pinPosition: {
            x: -19,
            y: 0,
          },
          clueType: "decoy",
          decoy: `An image showing another drone in the vicinity, revealed to be a photoshopped decoy.​ ByteFox planted this fake image to confuse investigators into thinking multiple drones were part of the operation.`,
        },
      ],
    },
  },
];
